import SentenceStudyListeningFillInTheBlankBase from 'es6/controllers/apps/quizzes/sentence-study-listening-fill-in-the-blank-base';

const MAX_HINTS = 1;

/**
 * Base class for the listening and translation assembly quizzes.
 */
export class SentenceStudyListeningFillInTheBlankPartial extends SentenceStudyListeningFillInTheBlankBase {
  constructor(...args) {
    super(...args);
    this._mode = 'chunk';
    this._setQuizType('SentenceStudyListeningFillInTheBlankPartial');
  }

  /**
   * @override
   * @returns {Number}
   */
  _getMaxHints() {
    return MAX_HINTS;
  }
}

export default SentenceStudyListeningFillInTheBlankPartial;
